import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-hole-position-tables',
  templateUrl: './hole-position-tables.component.html',
  styleUrls: ['./hole-position-tables.component.scss']
})
export class HolePositionTablesComponent implements OnInit, OnChanges {
  @Input() hasPinsheet: boolean = false;
  @Input() greenList: any = []
  leftHolesCount: number = 0;
  rightHolesCount: number = 0;
  frontHolesCount: number = 0;
  middleHolesCount: number = 0;
  backHolesCount: number = 0;
  
  constructor(
  ) {
  }   

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.setHolesCount()
  }

  setHolesCount() {
    if(this.hasPinsheet) {
      if(this.greenList && this.greenList.length) {
        this.leftHolesCount = 0
        this.rightHolesCount = 0
        this.frontHolesCount = 0
        this.middleHolesCount = 0
        this.backHolesCount = 0
        this.greenList.map((v:any) => {
          if(v.PositionY.includes('L')) {
            this.leftHolesCount += 1
          }
          else if(v.PositionY.includes('R')) {
            this.rightHolesCount += 1
          }
          if(v.PositionX) {
            if(+v.PositionX <= +v.Depth/3) {
              this.frontHolesCount += 1
            }
            else if(+v.PositionX > +v.Depth/3 && +v.PositionX <=  (+v.Depth/3)*2) {
              this.middleHolesCount += 1
            }
            else if(+v.PositionX > (+v.Depth/3)*2 && +v.PositionX <=  +v.Depth) {
              this.backHolesCount += 1
            }
          }
        })
      }
    }
  }


}
